// auth.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import StorageHelper from '../../../utils/storage-helper';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    StorageHelper.get('isAuthenticated') === true
  );
  const [user, setUser] = useState(null);

  const login = (user) => {
    StorageHelper.set('isAuthenticated', true);
    setIsAuthenticated(true);
    setUser(user);
  };

  const logout = () => {
    StorageHelper.clear();
    setIsAuthenticated(false);
    setUser(null);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextValue = useMemo(() => ({ isAuthenticated, user, login, logout }), [isAuthenticated, user]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
